"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Radio = _interopRequireDefault(require("./Radio"));

var RadioGroup =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(RadioGroup, _Component);

  function RadioGroup(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RadioGroup);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RadioGroup).call(this, props));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    var defaultValue = props.defaultValue,
        value = props.value;
    var stateValue = value || defaultValue || '';
    _this.state = {
      value: stateValue
    };
    return _this;
  }

  (0, _createClass2.default)(RadioGroup, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('value' in nextProps) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var onChange = this.props.onChange;
      var value = event.target.value;
      this.setState({
        value: value
      });

      if (onChange) {
        onChange(event, value);
      }
    }
  }, {
    key: "renderRadio",
    value: function renderRadio(props) {
      var _this$props = this.props,
          radioWrapClassName = _this$props.radioWrapClassName,
          radioWrapTag = _this$props.radioWrapTag;
      var stateValue = this.state.value;
      var onChange = props.onChange,
          value = props.value,
          other = (0, _objectWithoutProperties2.default)(props, ["onChange", "value"]);

      var radio = _react.default.createElement(_Radio.default, (0, _extends2.default)({}, other, {
        checked: value === stateValue,
        key: value,
        value: value,
        onChange: this.handleChange
      }));

      if (radioWrapTag) {
        var WrapTag = radioWrapTag;
        return _react.default.createElement(WrapTag, {
          className: radioWrapClassName
        }, radio);
      }

      return radio;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className;

      var options = _react.default.Children.map(children, function (option) {
        return _this2.renderRadio(option.props);
      }, this);

      return _react.default.createElement("div", {
        className: className
      }, options);
    }
  }]);
  return RadioGroup;
}(_react.Component);

(0, _defineProperty2.default)(RadioGroup, "propTypes", {
  name: _propTypes.default.string.isRequired,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  defaultValue: _propTypes.default.string,
  radioWrapClassName: _propTypes.default.string,
  radioWrapTag: _propTypes.default.string,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func
});
(0, _defineProperty2.default)(RadioGroup, "defaultProps", {
  children: null,
  className: null,
  defaultValue: null,
  radioWrapClassName: null,
  radioWrapTag: null,
  value: null,
  onChange: null
});
var _default = RadioGroup;
exports.default = _default;